import { api } from "../../api";

const rolesApi = api.injectEndpoints({
  tagTypes: ["Roles", "Permissions", "Users", "CurrentUser"],
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: () => "roles",
      transformResponse: (response) => response.roles || [],
      providesTags: (result) =>
        result?.length
          ? [
              ...result.map(({ id }) => ({ type: "Roles", id })),
              { type: "Roles", id: "LIST" },
            ]
          : [{ type: "Roles", id: "LIST" }],
    }),
    getPermissions: builder.query({
      query: () => "roles/permissions",
      transformResponse: (response) => response.permissions || [],
      providesTags: [{ type: "Permissions", id: "CATALOG" }],
    }),
    createRole: builder.mutation({
      query: (body) => ({
        url: "roles",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Roles", id: "LIST" }, "CurrentUser"],
    }),
    updateRole: builder.mutation({
      query: ({ id, data }) => ({
        url: `roles/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Roles", id },
        { type: "Roles", id: "LIST" },
        "CurrentUser",
      ],
    }),
    deleteRole: builder.mutation({
      query: (id) => ({
        url: `roles/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Roles", id: "LIST" }, "CurrentUser"],
    }),
    assignUserRoles: builder.mutation({
      query: ({ id, tenantRoles }) => ({
        url: `roles/users/${id}`,
        method: "PUT",
        body: { tenantRoles },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Users", id },
        { type: "Users", id: "LIST" },
        "CurrentUser",
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAssignUserRolesMutation,
  useCreateRoleMutation,
  useDeleteRoleMutation,
  useGetPermissionsQuery,
  useGetRolesQuery,
  useUpdateRoleMutation,
} = rolesApi;

export default rolesApi;
